"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspacesService = void 0;
class WorkspacesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1CompaniesWorkspaces({ companyId, workspaceId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/{companyId}/workspaces/{workspaceId}',
            path: {
                companyId: companyId,
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    putApiV1CompaniesWorkspaces({ workspaceId, companyId, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/companies/{companyId}/workspaces/{workspaceId}',
            path: {
                workspaceId: workspaceId,
                companyId: companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    patchApiV1CompaniesWorkspaces({ companyId, workspaceId, requestBody, }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/companies/{companyId}/workspaces/{workspaceId}',
            path: {
                companyId: companyId,
                workspaceId: workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    deleteApiV1CompaniesWorkspaces({ companyId, workspaceId, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/companies/{companyId}/workspaces/{workspaceId}',
            path: {
                companyId: companyId,
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV1CompaniesWorkspaces({ companyId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/{companyId}/workspaces',
            path: {
                companyId: companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Workspace already exists.`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV2Workspaces({ workspaceId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/workspaces/{workspaceId}',
            path: {
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    putApiV2Workspaces({ workspaceId, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v2/workspaces/{workspaceId}',
            path: {
                workspaceId: workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    patchApiV2Workspaces({ workspaceId, requestBody, }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v2/workspaces/{workspaceId}',
            path: {
                workspaceId: workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    deleteApiV2Workspaces({ workspaceId, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v2/workspaces/{workspaceId}',
            path: {
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV2Workspaces1() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/workspaces',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV2Workspaces({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/workspaces',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV3Workspaces({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v3/workspaces',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV3WorkspacesTrialModesSettings() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v3/workspaces/trial/modes/settings',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV3WorkspacesTrialSettings({ portalMode, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v3/workspaces/trial/settings/{portalMode}',
            path: {
                portalMode: portalMode,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.WorkspacesService = WorkspacesService;
